














import {Component, Vue} from "vue-property-decorator";
import PasswordlessService from "@/components/domains/auth/passwordlessService";
import {AuthPolicy, formatRetireDate, shouldShowMailNotice} from "@/components/domains/auth/authPolicy";
import {AuthGetterTypes} from "@/store/auth/types";

/**
 * Signed-in notice for accounts without an email address (only while the
 * magic link is available). Closing hides it until the next page load.
 */
@Component
export default class MailAddressBanner extends Vue {
  name = "MailAddressBanner";

  policy: AuthPolicy | null = null;
  dismissed = false;

  get visible(): boolean {
    if (this.dismissed || this.$route.path === '/mail-address') return false;
    return shouldShowMailNotice(this.policy, this.$store.getters[AuthGetterTypes.getCurrentUser]);
  }

  get deadline(): string {
    return this.policy ? formatRetireDate(this.policy.noEmailPasswordLoginRetiresAt) : '';
  }

  mounted(): void {
    PasswordlessService.loadPolicy().then((p) => (this.policy = p));
  }
}
